export const lessonStateEnum = [
    {
        stateId: "PENDING",
        stateName: "待上课"
    },
    {
        stateId: "IN_PROGRESS",
        stateName: "上课中"
    },
    {
        stateId: "CANCELLED",
        stateName: "已取消"
    },
    {
        stateId: "COMPLETED",
        stateName: "已完成"
    }
]